import { Component } from '@angular/core'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeCardHeaderSkeletonComponent } from 'se-fe-card/skeleton'
import { SeFeSkeletonModule } from 'se-fe-skeleton'

@Component({
  selector: 'se-po-profile-player-info-skeleton',
  standalone: true,
  imports: [SeFeCardModule, SeFeCardHeaderSkeletonComponent, SeFeSkeletonModule],
  template: `
    <se-fe-card>
      <se-fe-card-header-skeleton seFeDataSize="section" [seFeDataHeavyBorder]="true" [seFeDataTitle]="true"></se-fe-card-header-skeleton>
      <se-fe-card-content><span seFeSkeleton="text"></span><span seFeSkeleton="text|short"></span></se-fe-card-content>
    </se-fe-card>
  `,
})
export class ProfilePlayerInfoSkeletonComponent {}
